<script lang="ts">

    import { onMount } from "svelte";
    import View from "../Components/Shared/View.svelte";
    import { GoogleAuth, FacebookAuth } from '@beyonk/svelte-social-auth';
    import { Alert, Button, Col, Icon, Modal, Row } from "sveltestrap";
    import { navigate } from "svelte-navigator";
    import { LottiePlayer } from '@lottiefiles/svelte-lottie-player';
    import { isHighAccuracy, playerPosition } from "../Services/geolocation";
    import { hasSavedGame, startGame } from "../Services/game";
    import { currentUser } from "../Services/user";
    import { gameDefaults as explorationGameDefaults } from "../Game/game_exploration";
    import { gameDefaults as normalGameDefaults } from "../Game/game";
import PlatformGeoSettingsLink from "../Components/Shared/PlatformGeoSettingsLink.svelte";

    let showRoutingLogo: boolean = true
    let showLoginError = false;
    let showLegalError = false
    let legalAccepted = false;
    let openLegalModal = false;
    let withoutRegister = false;

    onMount(() => setTimeout(stopIntro, 5500))

    function stopIntro(){
        showRoutingLogo = false
    }

    function onFacebookAuthSuccess(event){

        if (!legalAccepted) {
            showLegalError = true;
            return;
        }

        if (event.detail && event.detail.accessToken) {
            window.FB.api('/me?fields=id,name,email,public_profile', function(response) {
                console.log(response);
                
                currentUser.set({
                    name: response.name,
                    email: response.email,
                    image: ''
                });
            });
        }
    }

    function onGoogleAuthSuccess(event){

        if (!legalAccepted) {
            showLegalError = true;
            return;
        }

        if (event.returnValue) {
            currentUser.set({
                name: event.detail.user.Ru.tf,
                email: event.detail.user.Ru.Hv,
                image: event.detail.user.Ru.NN
            });
        }  
    }

    function continueWithoutRegister(): void {
        withoutRegister = true;
    }

    function toggleLegalModal(): void {
        openLegalModal = !openLegalModal;
    }

    function acceptLegalText(): void {
        legalAccepted = true;
        openLegalModal = false;
    }

    function onStartNewGame(): void {
        if ($hasSavedGame && !confirmOverwriteGame()) {
            return;
        }
        startGame(normalGameDefaults);
        navigate('/inicio');
    }

    function onExplorationMode(): void {
        if ($hasSavedGame && !confirmOverwriteGame()) {
            return;
        }
        startGame(explorationGameDefaults);
        navigate('/inicio');
    }

    function confirmOverwriteGame(): boolean {
        return confirm('Actualmente hay un juego guardado, si continuas lo borrarás. ¿Continuar?');
    }

</script>

<style lang="scss">

    .alert-item {
        background-color: #ffc107;
        padding: 5px 10px 5px 10px;
        color: #000;
    }

    .logo-container{
        flex: 1 1 0;
        background-color: #111181;
        display: flex;
        justify-content: center;
        align-items: center;

        img{
            filter: invert(100%);
            height: auto;
            max-width: 50%;
        }
    }


    .content-genius{
        position: relative;
    }

    .content-login{
        position: relative;
        flex: 1 1 0;
        border-top: 25px solid var(--color-primary);
        text-align: center;
        background-color: rgba(var(--color-primary-rgb), 0.8);
        color: #fff;
        align-items: center;
        justify-content: center;
        display: flex;
        flex-direction: column;
    }

    .footer{
        padding: 5px;
        text-align: center;
    }    

    .form-floating{
        width: 100%;
        max-width: 275px;
        margin: auto;
        position: relative;

        .phantom{
            position: absolute;
            z-index: 2;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
        }

        :global(button){
            min-height: 50px;
            border-radius: 5px !important;
            font-weight: bold !important;
        }
        :global(span){
            display: none;
        }
        :global(.facebook-auth){
            width: 110px;
            background-color: #fff !important;
            background-image: url('/images/face_icon.png');
            background-size: 40%;
            background-repeat: no-repeat;
            background-position: center;
            
            :global(img){
                display: none;
            }

            &::after{
                content: '';
                color: white !important;
                margin-left: 5px;
            }
        }

        :global(.google-auth){
            width: 110px;
            background-color: #fff !important;
            background-image: url('/images/gmail_icon.png');
            background-size: 40%;
            background-repeat: no-repeat;
            background-position: center;

            :global(img){
                display: none;
            }

            &::after{
                content: '';
                color: white !important;
                margin-left: 5px;
            }
        }

   
    }

    .legal-condition{
        margin: 0px !important;

        :global(#text-legal-button){
            color: #fff;
            font-family: 'PT Sans', sans-serif !important;
            font-weight: bold;
            font-style: italic;
            text-decoration: none;
        }
    }

    :global(#access-button){
        display: block;
        width: 100%;
        height: 50px;
        margin-top: 15px;
        font-weight: bold;
        font-size: 20px;
        color: #0E3CA5;
        border-color: #fff;
    }

    :global(#button-modal-legal){
        display: block;
        width: 100%;
        height: 50px;
        margin-top: 15px;
        font-size: 20px;
        color: #fff;
        background-color: var(--color-primary);
        border-color: var(--color-primary);
    }

    :global(.game-button){
        height: auto;
        max-height: 75px;
        background-color: var(--color-primary) !important;
        border-radius: 10px !important;
        border: none !important;
    }


    .contain-button{
        flex: 1 1 0;
        display: flex;
        margin-bottom: 10px;
        gap: 10px;
    }

    .contain-button-expo{
        flex: 1 1 0;
        display: flex;
    }

    :global(.button-normaly){
        width: 100%;
        background-color: var(--color-primary) !important;
        border-radius: 10px;
    }


    .check-coord{
        position: absolute;
        z-index: 99;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background-color: lightgrey;
        opacity: 0.75;
    }

    .container-group-button{
        padding: 10px 0 10px 0;
        width: 75%;
        height: 100%;
        max-height: 150px;
        display: flex;
        flex-direction: column;
    }

</style>



<View flex>

    {#if showRoutingLogo}
        <div class="logo-container">
            <img src="/images/pre_carga_logo_routingtales_animated.svg" alt="Routing Tales">
        </div>
    {:else}

        <div class="alerts">
            {#if !$currentUser}
                <div class="alert-item">
                    <Icon name="exclamation-triangle-fill"/>
                    <span>Tu correo electrónico no está validado, no podra subir imágenes. Pulse aquí para solucionarlo</span>
                </div>
            {/if}

            {#if !$playerPosition}
                <div class="alert-item">
                    <Icon name="compass"/><span> Activa la localización para acceder</span>
                </div>
            {:else if !$isHighAccuracy}
                <div class="alert-item">
                    <PlatformGeoSettingsLink>
                        <Icon name="compass"/><span> No podemos ubicarte de forma precisa</span>
                    </PlatformGeoSettingsLink>
                </div>
            {/if}
        </div>

        <div class="content-genius">
            <LottiePlayer
                src="/lottie/elgenio.json"
                autoplay="{true}"
                loop="{true}"
                renderer="svg"
                background="transparent"
                height="auto"
                width="100%" />
        </div>

        <div class="content-login">
        
            <div class:check-coord={!$playerPosition}></div>

            {#if !$currentUser && !withoutRegister}

                <p class="mb-1">Acceder</p>
                <div class="row text-center login-blue">
                    <div class="col-12">
                        <div class="text-center">                
                            <div class="form-floating"> 
                                {#if !legalAccepted}
                                    <div class="phantom" on:click={toggleLegalModal}></div>
                                {/if}
                                <div class="row content-auth">
                                    <div class="col-6">
                                        <GoogleAuth clientId="764442144253-orrv41btqdtbpjagdg1kvlva96fg4v36.apps.googleusercontent.com" on:auth-success={onGoogleAuthSuccess} />
                                    </div>
                                    <div class="col-6">
                                        <FacebookAuth appId="498227842048377" on:auth-success={onFacebookAuthSuccess}/>
                                    </div>

                                </div>
                            </div>
        
                            <div class="legal-condition">
                                <Row>
                                    <Col class="d-flex align-items-center" xs="12"> 
                                        <input class="form-check" type="checkbox"  bind:checked={legalAccepted}>
                                        <Button color="link" id="text-legal-button" on:click={toggleLegalModal}>Acepto las condiciones de privacidad</Button>
                                    </Col>
                                </Row>
                            </div>

                            <div class="col-12 mt-1">
                                <Button class="button-normaly" type="button" on:click={continueWithoutRegister}>Acceder sin registro</Button>
                            </div>                  
        
                            {#if showLoginError}
                                <Alert>
                                    Ha ocurrido un error
                                </Alert>
                            {/if}
        
                            {#if showLegalError && !legalAccepted}
                                <Alert>
                                    Debe aceptar las condiciones legales, para poder acceder al Genio
                                </Alert>
                            {/if}
        
                        </div>
                
                    </div>
                </div>
            {/if}

            {#if $currentUser || withoutRegister}
                <div class="container-group-button">
                    <div class="contain-button">
                        <Button class="game-button" block type="button" on:click={onStartNewGame} color="primary">Nuevo Juego</Button>
                        {#if $hasSavedGame}
                            <Button class="game-button" block type="button" on:click={() => navigate('/game')} color="primary" >Continuar</Button>
                        {/if}
                    </div>
                    <div class="contain-button-expo">
                        <Button class="game-button" block type="button" on:click={onExplorationMode} color="primary">Modo Exploración</Button>
                    </div>
                </div>
            {/if}

        </div>
        <div class="footer">
            <img class="img-logo" src="/images/logo-realejos.png" alt="">
        </div>

    
    {/if}

    <Modal class="modal-dialog-centered modal-dialog-scrollable" body header="" isOpen={openLegalModal} toggle={toggleLegalModal}>
        <Col>
            <div class="third-tittle">
                <span><strong>Texto Legal</strong></span> 
                <br><br>
                <span>Conforme a lo previsto en la Ley Orgánica 15/99 de 13 de diciembre, de protección de datos de carácter personal, ponemos en conocimiento que los datos extraídos de esta aplicación serán destinados única y exclusivamente para la finalidad objeto de la misma, formando parte de un fichero informático cuyo responsable es el Ayuntamiento de Los Realejos, a quien podrá dirigirse para hacer uso de los derechos que le confiere la mencionada Ley Orgánica.</span>
                <br><br>
                <span><strong>Acepte las condiciones de privacidad</strong></span> 
            </div>
         </Col>
        <Col class="text-center mt-3">
            <div class="d-grid gap-2">
                <Button id="button-modal-legal" color="danger" on:click={acceptLegalText}>
                    <span class="third-tittle"><strong>Entendido</strong></span>
                </Button>
            </div>
        </Col>
    </Modal>

</View>



